var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpsonlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.465 100.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#10218b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M196.223,14.336c-19.209,0-30.299,14.396-30.299,34.126s11.09,34.124,30.299,34.124,30.299-14.394,30.299-34.124-11.09-34.126-30.299-34.126h0Zm0,56.769c-12.201,0-16.906-11.23-16.906-22.644s4.705-22.646,16.906-22.646,16.906,11.233,16.906,22.646-4.707,22.644-16.906,22.644Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "0 16.249 48.149 16.249 48.149 27.731 13.397 27.731 13.397 42.019 45.805 42.019 45.805 53.217 13.397 53.217 13.397 69.188 48.149 69.188 48.149 80.672 0 80.672 0 16.249"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M53.887,80.672h13.393v-19.326h12.135c16.395,0,27.41-8.064,27.41-22.548s-11.016-22.549-27.41-22.549h-25.527V80.672h0Zm25.527-30.805h-12.135V27.729l-.002-.002h12.137c8.418,0,14.018,3.666,14.018,11.07s-5.6,11.07-14.018,11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M245.342,16.249h-13.758V80.672h13.125v-26.098c0-7.132-.26-13.476-.5-19.074,1.549,3.223,6.244,12.914,8.426,16.554l17.082,28.617h13.748V16.249h-13.123v25.447c0,7.135,.26,14.128,.498,19.726-1.549-3.223-6.242-12.914-8.428-16.554l-17.07-28.619h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M122.032,59.356c0,8.658,7.202,12.031,14.861,12.031,5.011,0,13.126-1.459,13.126-8.111,0-7.018-9.928-8.344-19.498-10.895-10.04-2.652-19.695-6.425-19.695-18.361,0-13.303,12.576-19.684,24.333-19.684,13.579,0,26.061,5.926,26.061,20.963h-13.393c-.457-7.838-6.469-9.844-13.304-9.844-4.563,0-10.306,1.913-10.306,7.383,0,5.01,3.274,5.789,19.59,9.982,4.738,1.184,19.603,4.051,19.603,18.814,0,11.937-9.383,20.869-27.07,20.869-14.397,0-27.885-7.107-27.702-23.148h13.394Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpsonlogo);
export default __webpack_public_path__ + "static/media/epsonlogo.a4812d7746e258cdbb5393e0df40bdc9.svg";
export { ForwardRef as ReactComponent };